import cleanersService from "@/services/cleanersService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      const res = await cleanersService.create(formData);
      dispatch("findAll");
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Reinigungskraft konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }) {
    try {
      const res = await cleanersService.findAll();
      commit("setAll", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Reinigungskräfte konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async search({ dispatch }, payload) {
    try {
      const res = await cleanersService.search(payload);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Reinigungskräfte konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findOne({ commit, dispatch }, { id }) {
    commit("setSingle", null);
    try {
      const res = await cleanersService.findOne({ id });
      commit("setSingle", JSON.parse(JSON.stringify(res.data)));
      return Promise.resolve({...res.data});
    } catch (error) {
      dispatch(
        "common/showError",
        "Reinigungskraft konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await cleanersService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Reinigungskraft konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      const res = await cleanersService.update(formData);
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Reinigungskraft wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Reinigungskraft konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
